import { DashboardModule, Form, Grid } from '@domain-group/suit-theme'

import type { ProviderModel } from '@models/types'

interface ProviderDetailsProps {
  providerSalesforceDetails: ProviderModel['salesforce_details'],
}

const ProviderDetails = (props: ProviderDetailsProps) => {
  const { providerSalesforceDetails } = props

  const providerDetailsPayload = [
    { label: 'Title', value: providerSalesforceDetails?.title },
    { label: 'Active', value: providerSalesforceDetails?.active ? 'Active' : 'Inactive' },
    { label: 'Business Number', value: providerSalesforceDetails?.business_number },
  ]

  return (
    <DashboardModule title="Provider Details">
      <Grid
        // @ts-expect-error TS2322
        gridGap="large"
        gridTemplateColumns={[
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(1, minmax(160px, 1fr))',
          'repeat(2, minmax(160px, 1fr))',
        ]}
        padding="large"
      >
        {providerDetailsPayload.map(field => (
          <Form.Field label={field.label}>
            <input
              disabled
              type="text"
              value={field.value}
            />
          </Form.Field>
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default ProviderDetails
